module.exports = __webpack_public_path__ + "img/szhjs.2846ca05.png";